"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StaticComponent = void 0;
const react_1 = __importStar(require("react"));
const uuid_1 = require("uuid");
const monera_app_core_1 = require("@amzn/monera-app-core");
const config_1 = require("@amzn/monera-app-core/lib/utils/config");
const metric_helper_1 = require("@amzn/monera-app-core/lib/utils/metric-helper");
const server_1 = require("@amzn/monera-app-core/lib/utils/server");
const page_wrapper_1 = require("../page-wrapper");
const static_component_debug_1 = require("../static-component-debug");
const StaticComponent = (props) => {
    const { id, state = {}, children, debug = {
        depth: 0
    } } = props;
    const { componentsMap, pageType } = (0, react_1.useContext)(page_wrapper_1.PageContext);
    const [componentProps, setComponentProps] = (0, react_1.useState)(state);
    const [configStoreState] = (0, monera_app_core_1.useConfigStore)();
    const [shoppingPortalState] = (0, monera_app_core_1.useShoppingPortalStore)();
    (0, react_1.useEffect)(() => {
        function lazyLoad() {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                if (!window.moneraTenant) {
                    (0, config_1.initClientsideConfig)(configStoreState, shoppingPortalState.deviceType || monera_app_core_1.DeviceType.Desktop);
                    yield (0, monera_app_core_1.initClientsideStoreRegistry)(configStoreState.requestId);
                }
                try {
                    const componentRes = yield (0, monera_app_core_1.queryMoneraService)({
                        gqlQuery: monera_app_core_1.hydrateComponentsQuery,
                        variables: {
                            asin: configStoreState.asin,
                            customerId: shoppingPortalState.customerId,
                            deviceType: shoppingPortalState.deviceType,
                            platformType: (0, monera_app_core_1.getPlatformType)(shoppingPortalState.deviceAttributes),
                            marketplaceId: shoppingPortalState.marketplaceId,
                            locale: shoppingPortalState.locale,
                            pageType,
                            components: [{ id, state }]
                        },
                        headers: {
                            [monera_app_core_1.ShoppingPortalHeadersEnum.RequestId]: configStoreState.requestId,
                            [monera_app_core_1.ShoppingPortalHeadersEnum.UBID]: shoppingPortalState.ubid,
                            [monera_app_core_1.ShoppingPortalHeadersEnum.SessionId]: shoppingPortalState.sessionId,
                            [monera_app_core_1.HTTPHeaders.XForwardedFor]: shoppingPortalState.forwardedFor,
                            [monera_app_core_1.ShoppingPortalHeadersEnum.InternalIpClass]: shoppingPortalState.internalIpClass,
                            [monera_app_core_1.ShoppingPortalHeadersEnum.SlateToken]: shoppingPortalState.slateToken
                        },
                        isPartialPageRequest: true
                    });
                    if ((_c = (_b = (_a = componentRes.data) === null || _a === void 0 ? void 0 : _a.hydrateComponents) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.state) {
                        (0, metric_helper_1.meterFatals)({
                            methodName: 'lazyLoad',
                            metricName: 'hydrateComponentsQuery',
                            success: true,
                            requestId: configStoreState.requestId
                        });
                        return Object.assign(Object.assign({}, componentRes.data.hydrateComponents[0].state), { isLoading: false });
                    }
                    else {
                        throw new Error('hydrateComponentsQuery response did not contain the expected response');
                    }
                }
                catch (e) {
                    (0, metric_helper_1.meterFatals)({
                        methodName: 'lazyLoad',
                        metricName: 'hydrateComponentsQuery',
                        fault: true,
                        requestId: configStoreState.requestId
                    });
                    return undefined;
                }
            });
        }
        if (state.isLoading) {
            lazyLoad().then((state) => {
                state ? setComponentProps(state) : setComponentProps(Object.assign(Object.assign({}, componentProps), { isLoading: false }));
            });
        }
    }, []);
    const getChildrenIds = () => (children ? children.map((child) => child.id) : []);
    const renderChildren = () => {
        return (children &&
            children.map((child) => (react_1.default.createElement(exports.StaticComponent, { key: (0, uuid_1.v4)(), id: child.id, state: child.state, debug: { depth: debug.depth + 1, forceDebug: debug.forceDebug } }, child.children))));
    };
    const renderComponent = (componentsMap) => {
        const Component = componentsMap[id];
        if (!Component) {
            return react_1.default.createElement(react_1.default.Fragment, null, renderChildren());
        }
        return react_1.default.createElement(Component, Object.assign({}, componentProps), renderChildren());
    };
    if (!componentsMap[id]) {
        server_1.serverConsole.error(`"${id}" is NOT in static component registry`);
        return (react_1.default.createElement(static_component_debug_1.StaticComponentDebug, { id: id, state: state, childrenIds: getChildrenIds(), debug: {
                depth: debug.depth + 1,
                forceDebug: debug.forceDebug,
                name: 'unknown',
                componentMissing: true
            } }, renderComponent(componentsMap)));
    }
    return (react_1.default.createElement(static_component_debug_1.StaticComponentDebug, { id: id, state: state, childrenIds: getChildrenIds(), debug: {
            depth: debug.depth + 1,
            forceDebug: debug.forceDebug,
            name: id
        } }, renderComponent(componentsMap)));
};
exports.StaticComponent = StaticComponent;
__exportStar(require("./types"), exports);
